var Request = require('../helper/request');

function User(app, branchId){
	var self = this;
  self.request = new Request(app);
  self.branchId = branchId;

  self.routes = {
  	index: {
  		url: '/branch/'+self.branchId+'/user',
  		method: 'GET'
  	},
  	create: {
  		url: '/branch/'+self.branchId+'/user',
  		method: 'POST'
  	}
  };
}

User.prototype.index = function(){
	var self = this;
	return self.request.get(self.routes.index.url);
}

User.prototype.paginate = function(page){
  var self = this;
  var uri = self.routes.index.url + '?page=' + page;
  return self.request.get(uri);
}

User.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		user: data
	});
}

module.exports = User;